export class PackageGroupRequest {
  /**
   * @param {String[]} packageIds
   */
  constructor(packageIds) {
    this.packageIds = packageIds;
  }
}



// WEBPACK FOOTER //
// ./src/features/group/models/PackageGroupRequest.js